import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalAddeditComboComponent } from './modal-addedit-combo.component';
import { ModalReservaComboComponent } from './modal-reserva-combo.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import gql from 'graphql-tag';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-combos',
  templateUrl: './combos.component.html',
  styleUrls: ['./combos.component.scss'],
  providers: [SecurityService],
})
export class CombosComponent implements OnInit, OnDestroy {

  // Inputs
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = []
  @Input() permiteUnidadNegocio: any = []

  // Modales
  @ViewChild(ModalAddeditComboComponent, { static: true }) modalAgregarEditarCombo: ModalAddeditComboComponent
  @ViewChild(ModalReservaComboComponent, { static: true }) modalReserva: ModalReservaComboComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  // @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent

  // Form
  formData: FormGroup

  // Constants
  private readonly TIPO_CLIENTE: String = `_CLIENTE_`
  private readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  listaCombos: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false
  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null
  clientesSeleccionadosFormatted: String = null
  // private tiposClientesSeleccionados: any = null
  // private tiposClientesSeleccionadosFormatted: String = null

    // check Estado descuentos especiales
    readonly RO_EstadoActivoCombo: number = 1
    readonly RO_EstadoInactivoCombo: number = 2
  // Utils
  private log: any
  private subs = new Subscription()

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('COMBOS')
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa()
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo()
    this.paginationContext.RecordsByPage = 10
    this.createForms()
    this.formChangesSubscriptions()
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

  trackByComboCodigo(index: number, item: any) {
    return item && item.codigo != null ? item.codigo : (item && item.sku ? item.sku : index)
  }

  /********* FORMS *********/
  createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      fechaInicio: [initDate],
      fechaFin: [currentDate],
      rutCliente: [''],
      estadoActCombo:[this.RO_EstadoActivoCombo]
    });
  }

  private formChangesSubscriptions() {
    this.subs.add(
      this.formData.get("rutCliente").valueChanges
        .pipe(filter(Boolean), debounceTime(1000))
        .subscribe((rutCliente: string) => {
          this.modalSeleccionarCliente.searchByRut(rutCliente)
        })
    )
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
  }

  // limpiarBuscarPorTiposClientes() {
  //   this.tiposClientesSeleccionados = null
  //   this.tiposClientesSeleccionadosFormatted = null
  // }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    // this.tiposClientesSeleccionados = null
  }

  // abrirModalSeleccion() {
  //   if (this.formData.get('buscarPor').value === this.TIPO_CLIENTE)
  //     this.abrirModalSeleccionarCliente()
  //   else if (this.formData.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
  //     this.abrirModalSeleccionarClientesTipos()
  // }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected()
  }

  // abrirModalSeleccionarClientesTipos() {
  //   this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  // }

  abrirModalAgregarCombo() {
    this.modalAgregarEditarCombo.show('ADD')
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.log(origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  // }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data)
    this.limpiarDataSeleccionada()
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
  }

  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    this.formData.get('rutCliente').setValue('')
    this.clientesSeleccionados = [data]
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
  }

  // onClienteTiposSeleccionado({ data, origen }) {
  //   this.log(origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.tiposClientesSeleccionados = data
  //   // this.log('seleccionados', data)
  //   // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
  //   this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.codigo).join(', ')
  //   this.log('onClienteTiposSeleccionado this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  // }

  // onClienteTiposSeleccionadoMain({ data, origen }) {
  //   this.log('onClienteTiposSeleccionadoMain', origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.tiposClientesSeleccionados = data
  //   this.log('onClienteTiposSeleccionadoMain seleccionados', data)
  //   // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
  //   this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.codigo).join(', ')
  //   // this.log('this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  // }

  // onClienteTiposSeleccionadoModal({ data, origen }) {
  //   this.log('onClienteTiposSeleccionadoModal', origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.tiposClientesSeleccionados = data
  //   this.log('onClienteTiposSeleccionadoModal seleccionados', data)
  //   // this.log('this.tiposClientesSeleccionados', this.tiposClientesSeleccionados)
  //   this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.codigo).join(', ')
  //   // this.log('this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted)
  // }
  /********* MODALS *********/

  /********* OPERATIONS *********/
  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1
    this.log(this.formData.value)

    const esTipoCliente = this.formData.get("buscarPor").value === this.TIPO_TIPO_CLIENTE

    const _variables = {
      rut_empresa: Number(this.rutEmpresa),
      // sucursal_codigo: Number(this.sucursalEmpresa),
      // cliente_proveedor_rut: 99999999,
      fecha_inicio_combo: this.formData.get('fechaInicio').value || '0001-01-01',
      fecha_caducidad_combo: this.formData.get('fechaFin').value || '0001-01-01',
      tipobusqueda_estado: this.formData.get('estadoActCombo').value,
      tipo_cliente: [],
      rut_cliente_multiple: [],
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    // if (esTipoCliente && this.tiposClientesSeleccionados) {
    //   _variables.tipo_cliente = this.tiposClientesSeleccionados.map(tipo => ({ codigo: tipo.codigo }))
    // }
    // else
    if (this.clientesSeleccionados) {
      _variables.rut_cliente_multiple = this.clientesSeleccionados.map(cliente => ({ rut: cliente.rut }))
    }

    this.loaded = false
    this.loading = true
    this.listaCombos = []

    const self = this
    this.gqlclient.query(
      {
        query: gql`
          query
            (
              $rut_empresa: Decimal,
              $fecha_inicio_combo: Date,
              $fecha_caducidad_combo: Date,
              $tipo_cliente: [tipo_clienteInputType],
              $rut_cliente_multiple: [cliente_proveedorInputType],
              $tipobusqueda_estado: Int,
              $paginaActual: Int,
              $cantidadRegistrosPorPagina: Int
            )
          {
            producto{
              obtenerSegunFiltroProductosCombo(
                filtro: {
                  exacto:{
                    empresa_rut: $rut_empresa
                    tipobusqueda_estado: $tipobusqueda_estado
                    fecha_inicio_combo: $fecha_inicio_combo
                    fecha_caducidad_combo: $fecha_caducidad_combo
                    rut_cliente_multiple: $rut_cliente_multiple
                    tipo_cliente: $tipo_cliente
                    codigo: -1
                    sku:""
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              )
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros{
                    codigo
                    sku
                    empresa_rut
                    descripcion
                    fecha_inicio_combo
                    fecha_caducidad_combo
                    activo
                    permiteEdicionCombo
                  }
                }
              }
            }

          }
         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // self.log(response)
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosCombo
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        self.paginationContext.RecordsCount = totalRegistros
        self.paginationContext.CurrentPage = paginaActual
        self.paginationContext.PagesCount = totalPaginas
        self.listaCombos = registros
        self.log(registros)
        self.loaded = true
        self.loading = false
      }
    );
  }

  ver({ empresa_rut, codigo }) {
    this.log(empresa_rut, codigo)
    this.modalAgregarEditarCombo.load(empresa_rut, codigo, false)
  }

  reserva({ empresa_rut, codigo }) {
    this.log(empresa_rut, codigo)
    this.modalReserva.load(empresa_rut, codigo)
  }

  editarCombo({ empresa_rut, codigo }) {
    this.log(empresa_rut, codigo)
    this.modalAgregarEditarCombo.load(empresa_rut, codigo, true)
  }

  onComboSaved() {
    this.log('onComboSaved')
    this.buscar(true)
  }

  confirmDesactivar(codigo: number) {
    this.modalConfirm.show(() => { this.desactivar(codigo) })
  }

  desactivar(codigo: number) {
    const combo = {
      empresa_rut: Number(this.rutEmpresa),
      // sucursal_codigo: Number(this.sucursalEmpresa),
      codigo,
      activo: false
    }

    const self = this
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation($entidad: productoInputType) {
            producto {
              cambiarEstado(entidad: $entidad) {
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  codigo
                  empresa_rut
                  activo
                }
              }
            }
          }
        `,
        variables: {
          entidad: combo
        },
      },
      function (_respuesta) {
        self.log(_respuesta)
        const { mensajes, respuesta } = _respuesta.data.producto.cambiarEstado
        const ok = respuesta !== null
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          return
        }
        else {
          self.toastrService.success('Combo desactivado con éxito')
          self.buscar(true)
        }
        // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
        //   alert('Registro grabado');
        //   self.editarModalDtoComercielas.hide();
        // } else {
        //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
        // }
      }
    );
  }
  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados)
  }

}
